import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useGetUserProfileQuery } from '../generated/graphql';
import { useNotification } from '../common/components/notification/NotificationContext';
import ProfileUpdateForm from '../common/components/userProfile/forms/UserProfileForm';
import PasswordUpdateForm from '../common/components/userProfile/forms/UserPasswordForm';
import ProfileLayout from '../common/components/userProfile/ProfileLayout';

const ProfileAccountPage: React.FC = () => {
  const { showError } = useNotification();

  const { error: profileError } = useGetUserProfileQuery({
    fetchPolicy: 'cache-first',
  });

  // Show error notification when profile fetch fails
  useEffect(() => {
    if (profileError) {
      showError('Failed to load profile data');
    }
  }, [profileError, showError]);

  return (
    <ProfileLayout>
      <Box display="flex" flexDirection="column" gap={3}>
        {/* Profile Information Section */}
        <Box>
          <Typography variant="h5" gutterBottom>
            Account Information
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={3}>
            Update your personal information and profile details
          </Typography>

          <Card sx={{ p: 2 }}>
            <ProfileUpdateForm />
          </Card>
        </Box>

        <Divider />

        {/* Password Section */}
        <Box>
          <Typography variant="h5" gutterBottom>
            Security
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={3}>
            Manage your password and account security
          </Typography>

          <Accordion defaultExpanded={false} disabled={true}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Box>
                <Typography variant="h6">Change Password</Typography>
                <Typography variant="body2" color="text.secondary">
                  Update your account password
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <PasswordUpdateForm />
            </AccordionDetails>
          </Accordion>
        </Box>
      </Box>
    </ProfileLayout>
  );
};

export default ProfileAccountPage;
